import App from "@/App.vue";

export default [
  {
    path: "/usuarios",
    name: "user",
    component: App,
    redirect: { name: "user list" },
    children: [
      {
        path: "",
        name: "user list",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/UserList.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Usuários",
              disabled: false,
              link: false,
              to: { name: "user" }
            }
          ],
          displayName: "Lista Usuários - Lockton",
          requiresAuth: true
        }
      },
      {
        path: ":userId",
        name: "user details",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/UserDetails.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Usuário",
              disabled: false,
              link: true,
              to: { name: "user" }
            }
          ],
          displayName: "Detalhes do Usuário - Lockton",
          requiresAuth: true
        }
      },
      {
        path: "novo-usuario",
        name: "user new",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/UserDetails.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Usuário",
              disabled: false,
              link: true,
              to: { name: "user" }
            }
          ],
          displayName: "Novo Usuário - Lockton",
          requiresAuth: true
        }
      }
    ]
  }
];
